import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { TableCell, TableRow } from '@achra/ui/table';
import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { useMemo } from 'react';
import slugify from 'slugify';
import type { ExpenseReport_ExpenseReportStatus } from '@/modules/__generated__/graphql/switchboard-generated';
import { LastModified } from '@/modules/builders/components/builders/components/last-modified';
import { formatReportingMonth, getAmountByMetric } from '@/modules/finances/lib/budget-statement-utils';
import type { BudgetStatement, MetricWithoutBudget } from '@/modules/finances/types';
import { usLocalizedNumber } from '@/modules/shared/lib/humanization';
import { BudgetStatementsStatus } from '../budget-statements-status/budget-statements-status';
import { ContributorProfileInfo } from '../contributor-profile-info/contributor-profile-info';
export interface BudgetStatementTableItemProps {
  budgetStatement: BudgetStatement;
  budgetMetric: MetricWithoutBudget;
  className?: string;
}
function BudgetStatementTableItem(t0) {
  const $ = _c(49);
  const {
    budgetStatement,
    budgetMetric,
    className
  } = t0;
  let reportMonth;
  let t1;
  if ($[0] !== budgetStatement.month) {
    reportMonth = formatReportingMonth(budgetStatement.month);
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /\s+/g;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = reportMonth.replaceAll(t2, "");
    $[0] = budgetStatement.month;
    $[1] = reportMonth;
    $[2] = t1;
  } else {
    reportMonth = $[1];
    t1 = $[2];
  }
  const reportMonthTrimmed = t1;
  let t2;
  if ($[4] !== budgetMetric || $[5] !== budgetStatement) {
    t2 = getAmountByMetric(budgetMetric, budgetStatement);
    $[4] = budgetMetric;
    $[5] = budgetStatement;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const amount = t2;
  let t3;
  if ($[7] !== budgetStatement.owner.name) {
    t3 = slugify(budgetStatement.owner.name.toLocaleLowerCase());
    $[7] = budgetStatement.owner.name;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const ownerNameForNavigation = t3;
  const t4 = `/network/powerhouse/builders/${ownerNameForNavigation}/budget-statements?viewMonth=${reportMonthTrimmed}`;
  let t5;
  if ($[9] !== budgetStatement.owner.code || $[10] !== budgetStatement.owner.logo || $[11] !== budgetStatement.owner.name) {
    t5 = <ContributorProfileInfo name={budgetStatement.owner.name} code={budgetStatement.owner.code} isCoreUnit={true} logoUrl={budgetStatement.owner.logo} />;
    $[9] = budgetStatement.owner.code;
    $[10] = budgetStatement.owner.logo;
    $[11] = budgetStatement.owner.name;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <TableCell className="flex h-full w-[27%] p-0!"><Link href={t4} className="flex h-full w-full items-center pl-4">{t5}</Link></TableCell>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = `/network/powerhouse/builders/${ownerNameForNavigation}/budget-statements?viewMonth=${reportMonthTrimmed}`;
  let t8;
  if ($[16] !== reportMonth) {
    t8 = <div className="text-foreground text-sm/5.5 font-semibold">{reportMonth}</div>;
    $[16] = reportMonth;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <TableCell className="inline-block h-full w-[17%] p-0!"><Link href={t7} className="flex h-full w-full items-center">{t8}</Link></TableCell>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = `/network/powerhouse/builders/${ownerNameForNavigation}/budget-statements?viewMonth=${reportMonthTrimmed}`;
  let t11;
  if ($[21] !== amount) {
    t11 = usLocalizedNumber(amount);
    $[21] = amount;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <div className="text-foreground text-sm/5.5 font-semibold">{t11} USD</div>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12) {
    t13 = <TableCell className="inline-block h-full w-[15%] p-0! text-right"><Link href={t10} className="flex h-full w-full items-center justify-start">{t12}</Link></TableCell>;
    $[25] = t10;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const t14 = `/network/powerhouse/builders/${ownerNameForNavigation}/budget-statements?viewMonth=${reportMonthTrimmed}`;
  const t15 = budgetStatement.status as ExpenseReport_ExpenseReportStatus;
  let t16;
  if ($[28] !== t15) {
    t16 = <BudgetStatementsStatus status={t15} />;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t14 || $[31] !== t16) {
    t17 = <TableCell className="inline-block h-full w-[14%] p-0! text-right"><Link href={t14} className="flex h-full w-full items-center justify-start">{t16}</Link></TableCell>;
    $[30] = t14;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  const t18 = `/network/powerhouse/builders/${ownerNameForNavigation}/budget-statements?viewMonth=${reportMonthTrimmed}`;
  let t19;
  if ($[33] !== budgetStatement.lastModifiedAtUtcIso) {
    t19 = <span className="text-foreground text-sm/5.5 font-semibold"><LastModified lastModified={budgetStatement.lastModifiedAtUtcIso} /></span>;
    $[33] = budgetStatement.lastModifiedAtUtcIso;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t18 || $[36] !== t19) {
    t20 = <TableCell className="inline-block h-full flex-1 p-0! text-right"><Link href={t18} className="flex h-full w-full items-center justify-start">{t19}</Link></TableCell>;
    $[35] = t18;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  const t21 = `/network/powerhouse/builders/${ownerNameForNavigation}/budget-statements?viewMonth=${reportMonthTrimmed}`;
  let t22;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Button variant="outline" asChild={true} className="pointer-events-none"><div><span className="hidden lg:block">View</span><ArrowRight className="size-4 transition-transform duration-200 ease-in-out group-hover/link:translate-x-1.5" /></div></Button>;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t21) {
    t23 = <TableCell className="inline-flex h-full w-fit p-0! text-right"><Link href={t21} className="group/link flex h-full w-full items-center justify-end pr-4">{t22}</Link></TableCell>;
    $[39] = t21;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== className || $[42] !== t13 || $[43] !== t17 || $[44] !== t20 || $[45] !== t23 || $[46] !== t6 || $[47] !== t9) {
    t24 = <TableRow className={className}>{t6}{t9}{t13}{t17}{t20}{t23}</TableRow>;
    $[41] = className;
    $[42] = t13;
    $[43] = t17;
    $[44] = t20;
    $[45] = t23;
    $[46] = t6;
    $[47] = t9;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  return t24;
}
export { BudgetStatementTableItem };